import { InputHTMLAttributes, forwardRef } from 'react';
import { cn } from '@/lib/cn';

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  hint?: string;
}

export const Input = forwardRef<HTMLInputElement, Props>(function Input(
  { label, error, hint, className, id, type = 'text', ...rest },
  ref,
) {
  const inputId = id ?? rest.name;
  return (
    <label htmlFor={inputId} className="block w-full">
      {label && <span className="mb-1.5 block text-sm font-medium text-app-text">{label}</span>}
      <input
        ref={ref}
        id={inputId}
        type={type}
        className={cn(
          // text-base (16px) on mobile prevents iOS Safari from auto-zooming
          // on focus; drop back to text-sm from sm: up.
          'flex h-10 w-full rounded-md border border-app-border bg-app-field px-3 py-2 text-base sm:text-sm text-app-text transition-colors',
          'placeholder:text-app-hint',
          // Soft neutral focus: just deepen the border, no coloured ring.
          'focus-visible:outline-none focus-visible:border-app-text/30',
          'disabled:cursor-not-allowed disabled:opacity-50',
          'file:border-0 file:bg-transparent file:text-sm file:font-medium',
          error && 'border-destructive focus-visible:border-destructive',
          className,
        )}
        {...rest}
      />
      {error ? (
        <span className="mt-1 block text-xs text-destructive">{error}</span>
      ) : hint ? (
        <span className="mt-1 block text-xs text-app-hint">{hint}</span>
      ) : null}
    </label>
  );
});
